module.exports = __webpack_public_path__ + "img/smartphone-home@2x.1a5f412f.png";